<template>
    <div id="editarIdImportadorCotizacionesModal">

        <ui-modal
            :title="`Editar Cotización - ${ quotationNumber }`"
            size="large" 
            ref="modal" 
            @close="actionSetShowDataTableQuotationImporterModal(false)"
        >
            <importador-cotizaciones-form-component
                :fncAfterSave="getQuotationImporters"
                :idQuotation = "id"
            />
        </ui-modal>
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex';
import UiModal from "keen-ui/src/UiModal";
import ImportadorCotizacionesFormComponent from '../../../../common/forms/ImportadorCotizacionesFormComponent.vue';
import { getQuotationImporters } from '../../../../../constants/lineas';

export default {
    data() {
        return {};
    },
    props: ["id","quotationNumber"],

    components: { UiModal, ImportadorCotizacionesFormComponent },

    created() {},

    mounted() {},

    methods: {

        ...mapActions(["ActionSetZindexModal"]),

        ...mapActions("lineas", [ 
            'actionSetDataDataTableQuotationImporter',
            'actionSetDataDataTableQuotationImporterLoading',
            'actionSetShowDataTableQuotationImporterModal' 
        ]),


        openModal(ref){
            this.ActionSetZindexModal(true);
            this.$refs[ref].open();
        },
        closeModal(ref){
            this.ActionSetZindexModal(false);
            this.$refs[ref].close();
        },

        async getQuotationImporters(){

            this.actionSetDataDataTableQuotationImporterLoading( true )  ;

            const { data } = await getQuotationImporters() ;

            this.actionSetDataDataTableQuotationImporter( data )

            this.actionSetDataDataTableQuotationImporterLoading( false )  ;

            this.closeModal('modal') ;
        },
    },

    computed: {
        ...mapState( "lineas", ["showDataTableQuotationImporterModal"]),
    },

    watch: {
        showDataTableQuotationImporterModal : function( _new ){
            _new ? this.openModal('modal') : this.closeModal('modal') ;
        }
    }
};
</script>

<style>

#editarIdImportadorCotizacionesModal .ui-modal--size-large > .ui-modal__wrapper > .ui-modal__container {
    width: 90% !important;
}

</style>

